export const multipartFormDataConfig = {
    headers: {
        "content-type": "multipart/form-data",
    },
};
